<div mat-dialog-content>
    <div class="row" *ngIf="dataSource.data.length<=0">
        <div class="col-sm-12 text-danger">
                No Pending OPS Found.
            </div>
    </div>

    <div class="card text-center" *ngIf="dataSource.data.length>0">
        <div class="card-header bg-primary text-left text-white font-weight-bold">
            OPS List
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <!-- (keyup)="doFilter($event)"  -->
                    <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control"
                            placeholder="Filter">
                    </div>
                </div>

                <div class="col-sm-12">
                    <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc" multiTemplateDataRows>
                        <!-- Name Column -->
                        <ng-container matColumnDef="tempOpsNum">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Temp.No. </mat-header-cell>
                            <mat-cell *matCellDef="let element" (click)="OnOpsClick(element)"> {{element.tempOpsNum}} </mat-cell>
                        </ng-container>


                        <!-- Position Column -->
                        <ng-container matColumnDef="opsNum">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> OPS No. </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.opsNum}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="business">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Type </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.business}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="opsDate">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> OPS Date </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.opsDate}} </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="companyName">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Company </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.companyName}}</mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="OpsListHeader"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: OpsListHeader;"></mat-row>

                    </mat-table>
                </div>

                <div class="col-sm-12">
                    <div class="col-sm-6 float-right text-right">
                        <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>